export default {
  "viewDocument": "View",
  "unableToLoadBudgets": "Unable to load budgets.",
  "budgetUpdated": "Budget updated",
  "theBudgetDetailsHaveBeenSaved": "The budget details have been saved.",
  "unableToUpdateBudget": "Unable to update budget",
  "pleaseTryAgainInAMoment": "Please try again in a moment.",
  "budgetDeleted": "Budget deleted",
  "theBudgetHasBeenRemoved": "The budget has been removed.",
  "budgetCannotBeDeleted": "Budget cannot be deleted",
  "unableToDeleteBudget": "Unable to delete budget",
  "onlyDraftBudgetsWithoutLockedVersionsCanBeDeleted": "Only draft budgets without locked versions can be deleted.",
  "unableToCreateBudget": "Unable to create budget.",
  "newBudget": "New Budget",
  "createANewBudget": "Create a new budget",
  "name": "Name",
  "fy2025OperatingBudget": "FY 2025 Operating Budget",
  "fiscalYearStart": "Fiscal year start",
  "fiscalYearEnd": "Fiscal year end",
  "copyFromBudgetOptional": "Copy from budget (optional)",
  "selectBudget": "Select budget",
  "noCopy": "No copy",
  "copyFromVersionOptional": "Copy from version (optional)",
  "selectVersion": "Select version",
  "currentVersion": "Current version",
  "cancel": "Cancel",
  "createBudget": "Create Budget",
  "budgetingError": "Budgeting error",
  "loadingBudgets": "Loading budgets...",
  "editBudget": "Edit budget",
  "saveChanges": "Save changes",
  "deleteBudget": "Delete budget",
  "delete": "Delete",
  "noBudgetsYetClickNewBudgetToCreateYourFirstBudget": "No budgets yet. Click “New Budget” to create your first budget.",
  "fiscalYear": "Fiscal Year",
  "status": "Status",
  "updated": "Updated",
  "open": "Open",
  "openBudgetActions": "Open budget actions",
  "edit": "Edit",
  "jan": "Jan",
  "feb": "Feb",
  "mar": "Mar",
  "apr": "Apr",
  "may": "May",
  "jun": "Jun",
  "jul": "Jul",
  "aug": "Aug",
  "sep": "Sep",
  "oct": "Oct",
  "nov": "Nov",
  "dec": "Dec",
  "q1": "Q1",
  "q2": "Q2",
  "q3": "Q3",
  "q4": "Q4",
  "draft": "Draft",
  "submitted": "Submitted",
  "boardApproved": "Board approved",
  "locked": "Locked",
  "rejected": "Rejected",
  "originalBudget": "Original budget",
  "reforecast": "Reforecast",
  "boardMandated": "Board mandated",
  "other": "Other",
  "operating": "Operating",
  "capex": "CapEx",
  "fyDatesNotSet": "FY dates not set",
  "allDepartments": "All departments",
  "selectGlAccount": "Select GL account",
  "searchGlAccounts": "Search GL accounts...",
  "noGlAccountsFound": "No GL accounts found.",
  "selectDepartment": "Select department",
  "searchDepartments": "Search departments...",
  "noDepartmentsFound": "No departments found.",
  "unableToLoadBudgetDetails": "Unable to load budget details.",
  "unableToLoadReferenceData": "Unable to load reference data.",
  "unableToLoadBudgetLines": "Unable to load budget lines.",
  "couldntLoadYourAutosavePreference": "Couldn't load your auto-save preference",
  "autosaveIsOffByDefaultUntilWeCanLoadYourSetting": "Auto-save is off by default until we can load your setting.",
  "allCategories": "All categories",
  "lineAlreadyExists": "Line already exists",
  "aBudgetLineWithTheseDetailsAlreadyExists": "A budget line with these details already exists.",
  "unableToPrepareAttachments": "Unable to prepare attachments",
  "pleaseTryAgain": "Please try again.",
  "lineDetailsChanged": "Line details changed",
  "attachmentsWereClearedPleaseReuploadAnyDocuments": "Attachments were cleared. Please re-upload any documents.",
  "unableToDiscardDraftLine": "Unable to discard draft line",
  "autosaved": "Auto-saved",
  "changesSavedAutomatically": "Changes saved automatically.",
  "budgetSaved": "Budget saved",
  "changesHaveBeenSaved": "Changes have been saved.",
  "unableToSaveBudgetLines": "Unable to save budget lines.",
  "autosaveFailed": "Auto-save failed",
  "autosaveFailedPleaseClickSaveChanges": "Auto-save failed, please click Save Changes.",
  "readonlyVersion": "Read-only version",
  "readonlyVersionCantBeAutosaved": "Read-only version can’t be auto-saved.",
  "unableToUpdateAutosave": "Unable to update auto-save",
  "unableToDeleteLine": "Unable to delete line.",
  "newVersionCreated": "New version created",
  "aNewDraftVersionIsReadyForEditing": "A new draft version is ready for editing.",
  "unableToCreateNewVersion": "Unable to create new version.",
  "versionDetailsUpdated": "Version details updated",
  "versionMetadataSavedSuccessfully": "Version metadata saved successfully.",
  "unableToUpdateVersion": "Unable to update version",
  "pleaseTryAgainOrRefreshThePage": "Please try again or refresh the page.",
  "unableToUpdateCurrentVersion": "Unable to update current version.",
  "submittedToTheGmForReleaseVotingWillOpenOnceApproved": "Submitted to the GM for release — voting will open once approved.",
  "votingAlreadyOpen": "Voting already open",
  "votingIsAlreadyOpenForThisBudgetRefreshingTheMotionStatus": "Voting is already open for this budget. Refreshing the motion status.",
  "alreadySubmitted": "Already submitted",
  "thisBudgetIsAlreadyQueuedForGmRelease": "This budget is already queued for GM release.",
  "votingAlreadyClosed": "Voting already closed",
  "thisBudgetMotionHasAlreadyBeenClosed": "This budget motion has already been closed.",
  "submissionFailed": "Submission failed",
  "unableToSubmitThisBudgetForBoardApproval": "Unable to submit this budget for board approval.",
  "withdrawSubmissionThisWillRevertToDraftAndRemoveItFromTheBoardQueue": "Withdraw submission? This will revert to Draft and remove it from the board queue.",
  "submissionWithdrawnBudgetIsBackInDraft": "Submission withdrawn — budget is back in Draft.",
  "thisSubmissionCanOnlyBeWithdrawnBeforeVotingOpens": "This submission can only be withdrawn before voting opens.",
  "votesAlreadyExistForThisMotion": "Votes already exist for this motion.",
  "thisBudgetVersionIsNotCurrentlySubmitted": "This budget version is not currently submitted.",
  "noPendingMotionWasFoundForThisSubmission": "No pending motion was found for this submission.",
  "unableToWithdrawSubmission": "Unable to withdraw submission",
  "unableToDeleteBudgetEnsureItIsInDraftAndNoVersionsAreLocked": "Unable to delete budget. Ensure it is in draft and no versions are locked.",
  "statusUpdated": "Status updated",
  "unableToUpdateStatus": "Unable to update status",
  "thisReopensAnApprovedBudgetAndAllowsEditsContinue": "This reopens an approved budget and allows edits. Continue?",
  "lockedBudgetsCannotBeEditedAgainContinue": "Locked budgets cannot be edited again. Continue?",
  "loadingBudgetDetails": "Loading budget details...",
  "backToBudgeting": "Back to Budgeting",
  "budgetNotFound": "Budget not found",
  "theSelectedBudgetCouldNotBeFoundForThisClub": "The selected budget could not be found for this club.",
  "backToBudgets": "Back to Budgets",
  "newVersion": "New Version",
  "createANewVersion": "Create a new version",
  "createFromCurrentVersion": "Create from current version?",
  "copyFromSelectedVersion": "Copy from selected version",
  "blankVersionNoLines": "Blank version (no lines)",
  "label": "Label",
  "purpose": "Purpose",
  "notes": "Notes",
  "optionalNotesForThisVersion": "Optional notes for this version",
  "createVersion": "Create version",
  "setAsCurrent": "Set as Current",
  "viewInBoardPortal": "View in Board Portal",
  "submitForBoardApproval": "Submit for Board Approval",
  "withdrawSubmission": "Withdraw submission",
  "budgetSettings": "Budget settings",
  "disableAutosave": "Disable Auto-Save",
  "activateAutosave": "Activate Auto-Save",
  "confirmStatusChange": "Confirm status change",
  "confirm": "Confirm",
  "department": "Department",
  "category": "Category",
  "searchGl": "Search GL",
  "searchByGlAccount": "Search by GL account",
  "view": "View",
  "monthly": "Monthly",
  "quarterly": "Quarterly",
  "quarterlyViewEnabledForSmallerScreens": "Quarterly view enabled for smaller screens.",
  "addLine": "Add Line",
  "editBudgetLine": "Edit budget line",
  "addBudgetLine": "Add budget line",
  "glAccount": "GL Account",
  "ownerOptional": "Owner (optional)",
  "searchStaffByNameOrEmail": "Search staff by name or email",
  "unassigned": "Unassigned",
  "noMatches": "No matches",
  "typeAtLeast2CharactersToSearch": "Type at least 2 characters to search.",
  "searchingStaff": "Searching staff...",
  "selectAStaffMemberToAssignOwnership": "Select a staff member to assign ownership.",
  "uploadSupportingDocumentsForThisBudgetLine": "Upload supporting documents for this budget line.",
  "deleteThisBudgetLine": "Delete this budget line?",
  "thisWillRemoveTheLineFromTheVersionYouCanReaddItLaterIfNeeded": "This will remove the line from the version. You can re-add it later if needed.",
  "versionDetails": "Version details",
  "created": "Created",
  "saveDetails": "Save details",
  "saving": "Saving...",
  "thisVersionIsNotInDraftAndCannotBeEditedCreateANewVersionToContinueEditing": "This version is not in draft and cannot be edited. Create a new version to continue editing.",
  "somethingWentWrong": "Something went wrong",
  "total": "Total",
  "noBudgetLinesYetUseAddLineToStartBuildingYourBudget": "No budget lines yet. Use “Add Line” to start building your budget.",
  "lineActions": "Line actions",
  "editLine": "Edit line",
  "documents": "Documents...",
  "deleteLine": "Delete line",
  "supportingDocuments": "Supporting documents",
  "selectAGlAccountAndDepartmentToEnableDocumentUploads": "Select a GL account and department to enable document uploads.",
  "unableToLoadDocuments": "Unable to load documents",
  "uploadFailed": "Upload failed",
  "deleteFailed": "Delete failed",
  "downloadFailed": "Download failed",
  "previewFailed": "Preview failed",
  "dragDropFilesHere": "Drag & drop files here",
  "pdfImagesWordDocsMax25mbEach": "PDF, images, Word docs • max 25MB each",
  "hangTightWhileWePrepUploads": "Hang tight while we prep uploads.",
  "browseFiles": "Browse files",
  "loadingDocuments": "Loading documents...",
  "refresh": "Refresh",
  "download": "Download",
  "uploading": "Uploading",
  "failed": "Failed",
  "complete": "Complete",
  "noDocumentsAttachedYet": "No documents attached yet.",
  "documentPreview": "Document preview",
  "previewNotAvailableDownloadToViewThisFile": "Preview not available — download to view this file.",
  "budgetLineDocuments": "Budget line documents",
  "attachSupportingDocumentsForThisBudgetLine": "Attach supporting documents for this budget line.",
  "openNamed": "Open {name}",
  "deleteNamed": "Delete “{name}”? This can’t be undone.",
  "valuesCurrency": "All values in {currency} ({symbol})",
  "updatedAt": "Updated {date}",
  "createdAt": "Created {date}",
  "versionNumber": "Version v{number}",
  "reforecastVersion": "Reforecast (v{number})",
  "statusSet": "Budget status set to {status}.",
  "ownerName": "Owner: {name}",
  "departmentDefault": " (Dept default)",
  "autoSaveState": "Auto-Save: {state}",
  "on": "On",
  "off": "Off",
  "submitting": "Submitting...",
  "withdrawing": "Withdrawing...",
  "searching": "Searching...",
  "documentCountOne": "{count} document",
  "documentCountMany": "{count} documents",
  "uploadedAt": "Uploaded {date}",
  "noResults": "No budget lines match your filters.",
  "pending_open": "Submitted (Pending GM Open)",
  "votingOpen": "Voting Open",
  "votingClosed": "Voting Closed",
  "withdrawn": "Withdrawn",
  "close": "Close",
  "errors": {
    "permissionDenied": "You do not have permission to perform this action. Contact your club administrator.",
    "invalidFields": "Check the name, fiscal dates and selected budget/version, then try again.",
    "budgetMissing": "This budget is no longer available. Return to the budget list.",
    "versionMissing": "This version is no longer available. Refresh and select another version.",
    "lineMissing": "This line is no longer available. Refresh the budget.",
    "versionReadOnly": "This version is read-only. Create a new draft version to make changes.",
    "invalidTransition": "This status change is not allowed. Refresh to check the current status.",
    "deleteRestricted": "Only draft budgets without locked versions can be deleted.",
    "duplicateLine": "A budget line with these details already exists. Edit the existing line.",
    "fileTooLarge": "Choose a file no larger than 25 MB.",
    "fileType": "Choose a supported PDF, image or Word document.",
    "fileSizeMismatch": "The uploaded file size did not match. Try uploading the file again.",
    "attachmentMissing": "This document is no longer available. Refresh the document list.",
    "withdrawRestricted": "This submission can only be withdrawn before voting opens.",
    "votesExist": "Votes already exist for this motion.",
    "notSubmitted": "This budget version is not currently submitted.",
    "motionMissing": "No pending motion was found for this submission."
  },
  "deleteBudgetConfirm": "Delete budget?"
};
